'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = require('@utils/store');

var _store2 = _interopRequireDefault(_store);

var _mintUi = require('mint-ui');

var _utils = require('@utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var logo = require('@assets/images/logo.png');


function scrollToTop() {
  window.scrollTo(0, 0); //页面滚动到顶部
}

exports.default = {
  data: function data() {
    return {
      sysId: 'M0515',
      vipTitle: '山东省护理学会',
      vipLogo: '',
      defaultVipLogo: logo
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var sysInfo, arrInput, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input, arrTextarea, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, textarea;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sysInfo = _store2.default.localStorage.getItem(_store2.default.keys.sysInfo) || {};

              if (!_this.sysId && sysInfo && sysInfo.id) {
                _this.sysId = sysInfo.id;
                _this.vipTitle = sysInfo.title || '';
                _this.vipLogo = sysInfo.logo;
              }

              if (!(0, _utils.isIOS)()) {
                _context.next = 43;
                break;
              }

              arrInput = window.document.getElementsByTagName("input");
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 7;

              for (_iterator = arrInput[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                input = _step.value;

                input.removeEventListener('blur', scrollToTop);
                input.addEventListener('blur', scrollToTop, false);
              }
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](7);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 15:
              _context.prev = 15;
              _context.prev = 16;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 18:
              _context.prev = 18;

              if (!_didIteratorError) {
                _context.next = 21;
                break;
              }

              throw _iteratorError;

            case 21:
              return _context.finish(18);

            case 22:
              return _context.finish(15);

            case 23:
              arrTextarea = window.document.getElementsByTagName("textarea");
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 27;

              for (_iterator2 = arrTextarea[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                textarea = _step2.value;

                textarea.removeEventListener('blur', scrollToTop);
                textarea.addEventListener('blur', scrollToTop, false);
              }
              _context.next = 35;
              break;

            case 31:
              _context.prev = 31;
              _context.t1 = _context['catch'](27);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 35:
              _context.prev = 35;
              _context.prev = 36;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 38:
              _context.prev = 38;

              if (!_didIteratorError2) {
                _context.next = 41;
                break;
              }

              throw _iteratorError2;

            case 41:
              return _context.finish(38);

            case 42:
              return _context.finish(35);

            case 43:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[7, 11, 15, 23], [16,, 18, 22], [27, 31, 35, 43], [36,, 38, 42]]);
    }))();
  },

  methods: {
    /**
     * 跳转地址
     */
    go: function go(pageName) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.$router.push({ name: pageName, params: _extends({ id: this.sysId }, params), query: query });
    },


    /**
     * 返回
     */
    goBack: function goBack() {
      var page = _store2.default.sessionStorage.getItem(_store2.default.keys.backPage);
      if (page) {
        return this.$router.push({ name: page, params: { id: this.sysId } });;
      }
      this.$router.go(-1);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/common.js
// module id = 452
// module chunks = 14